// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import 'core-js';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import { Link } from '../_modules/link/link';
import '../_modules/home-content/home-content.js';
import RcommendationSearchPage from '../_modules/recommendation-search-page/recommendation-search-page';


$(() => {
  new Link(); // Activate Link modules logic
  new RcommendationSearchPage();
  console.log('Welcome to Yeogurt!!');
});
